module.exports = __webpack_public_path__ + "static/media/ils_gold_sell_success.85ce7abe.svg";